<template>
	<div class="d-inline-block" v-for="(style, index) in styles" :key="style.category">
		<router-view>
			<keep-alive>
				<component ref="component" :is="styles[index].component" :styles="styles[index]" @updateStyleEvent="updateStyle" />
			</keep-alive>
		</router-view>
		
		<Divider class="d-inline-block" layout="vertical" v-if="index != styles.length - 1" />
	</div>
</template>

<script lang="ts">
	import { defineComponent, ref } from "vue";
	import styleMixin from "@/mixin/style";
	
	export default defineComponent({
		emits: ['update-style-event'],
		mixins: [styleMixin],
		data() {
			return {
				//
			}
		},
		props: {
			cssStyle: {
				type: Object,
				required: false,
			},
			reloadKey: {
				type: String,
				required: true,
			}
		},
		watch: {
			reloadKey:{
				immediate: true,
				handler(newValue: any) {
					this.convertToStyle(this.cssStyle);
				},
			}			
		},
		methods: {
			resetSelectedOptions() {
				if (this.styles != null && this.styles.length > 0) {
					for (var i = 0; i < this.styles.length; i++) {
						if (this.styles[i].selectedOptions != null && this.styles[i].selectedOptions.length > 0) {
							for (var j = 0; j < this.styles[i].selectedOptions.length; j++) {
								this.styles[i].selectedOptions[j].options = null;
							}
						}
					}
				}
			},
			convertToStyle(cssStyle: any) {
				this.resetSelectedOptions();
				
				if (cssStyle != null) {
					if (this.styles != null && this.styles.length > 0) {
						for (let styleIndex = 0; styleIndex < this.styles.length; styleIndex++) {
							let optionItem = null as any;
		
							if (this.styles[styleIndex].category == 'border') {
								this.styles[styleIndex].selectedOptions[0].options = [];
								for (let optionIndex = 0; optionIndex < this.styles[styleIndex].types[0].options.length; optionIndex++) {
									const borderType = Object.keys(cssStyle).find(key => key == this.styles[styleIndex].types[0].options[optionIndex].name)
		
									if (borderType != null) {
										for (let typeIndex = 0; typeIndex < this.styles[styleIndex].types.length; typeIndex++) {
											optionItem = null as any;
											if (typeIndex == 0) {
												optionItem = this.styles[styleIndex].types[typeIndex].options.find((obj: any) => (obj.name == borderType && obj.value == cssStyle[borderType]))
												if (optionItem != null) {
													this.styles[styleIndex].selectedOptions[typeIndex].options.push(optionItem)
												}
											}
		
											else {
												optionItem = this.styles[styleIndex].types[typeIndex].options.find((obj: any) => (obj.name == this.styles[styleIndex].types[typeIndex].options[0].name && obj.value == cssStyle[borderType + this.styles[styleIndex].types[typeIndex].options[0].name]))
												if (optionItem != null) {
													this.styles[styleIndex].selectedOptions[typeIndex].options = optionItem
												}
											}
										}
									}
								}
							}
		
							else {
								for (let typeIndex = 0; typeIndex < this.styles[styleIndex].types.length; typeIndex++) {
									const cssType = Object.keys(cssStyle).find(key => key == this.styles[styleIndex].types[typeIndex].options[0].name)
		
									if (cssType != null) {
										if (this.styles[styleIndex].types[typeIndex].type == 'color') {
											optionItem = this.styles[styleIndex].types[typeIndex].options.find((obj: any) => (obj.name == this.styles[styleIndex].types[typeIndex].options[0].name))
											if (optionItem != null) {
												this.styles[styleIndex].selectedOptions[typeIndex].options = {...optionItem}
												this.styles[styleIndex].selectedOptions[typeIndex].options.value = cssStyle[cssType]
											}
										}
		
										else {
											optionItem = this.styles[styleIndex].types[typeIndex].options.find((obj: any) => (obj.name == this.styles[styleIndex].types[typeIndex].options[0].name && obj.value == cssStyle[this.styles[styleIndex].types[typeIndex].options[0].name]))
											if (optionItem != null) {
												this.styles[styleIndex].selectedOptions[typeIndex].options = optionItem
											}
										}
									}
								}
							}
						}
					}
				}
			},
			convertToCss() {
				const css = [] as any[];
				
				for (let i = 0; i < this.styles.length; i++) {
					if (this.styles[i].selectedOptions != null && this.styles[i].selectedOptions.length > 0) {
						if (this.styles[i].category == 'border') {
							if (this.styles[i].selectedOptions[0].options != null) {
								for (let j = 0; j < this.styles[i].selectedOptions[0].options.length; j++) {
									let borderType = this.styles[i].selectedOptions[0].options[j].name;
									css.push(this.formatCssString(borderType, this.styles[i].selectedOptions[0].options[j].value))
									
									if (this.styles[i].selectedOptions[1].options != null) {
										css.push(this.formatCssString(borderType + this.styles[i].selectedOptions[1].options.name, this.styles[i].selectedOptions[1].options.value));
										
										if (this.styles[i].selectedOptions[1].options.name == '-style' && this.styles[i].selectedOptions[1].options.value == 'double') {
											css.push(this.formatCssString(borderType + this.styles[i].types[2].options[1].name, this.styles[i].types[2].options[1].value));
										}
	
										else {
											css.push(this.formatCssString(borderType + this.styles[i].types[2].options[0].name, this.styles[i].types[2].options[0].value));
										}
										
									}
								}
							}
						}
	
						else {
							for (let j = 0; j < this.styles[i].selectedOptions.length; j++) {
								if (this.styles[i].selectedOptions[j].options != null) {
									css.push(this.formatCssString(this.styles[i].selectedOptions[j].options.name, this.styles[i].selectedOptions[j].options.value));
								}
							}
						}
					}
				}
				return JSON.parse("{" + css.join(",") + "}");
			},
			formatCssString(key: any, value: any) {
				return '"' + key + '":"' + value + '"';
			},
			updateStyle(data: any) {
				this.$emit('update-style-event', this.convertToCss())
			},
		}
	});
</script>